/* eslint-disable @typescript-eslint/naming-convention */
import { SimpleEvent } from '@eastsideco/salvo-ts';

interface SWCallbacks {
    SWCallbackExpressWishlistProductItemAdded?(): void;
    SWCallbackExpressWishlistProductItemRemoved?(): void;
    SWCallbackExpressWishlistCollectionItemAdded?(): void;
    SWCallbackExpressWishlistCollectionItemRemoved?(): void;
    SWCallbackCustomerWishlistProductItemAdded?(): void;
    SWCallbackCustomerWishlistProductItemRemoved?(): void;
    SWCallbackCustomerWishlistCollectionItemAdded?(): void;
    SWCallbackCustomerWishlistCollectionItemRemoved?(): void;
}

declare global {
    interface Window extends SWCallbacks { }
}

const allCallbacks: (keyof SWCallbacks)[] = [
    'SWCallbackExpressWishlistProductItemAdded',
    'SWCallbackExpressWishlistProductItemRemoved',
    'SWCallbackExpressWishlistCollectionItemAdded',
    'SWCallbackExpressWishlistCollectionItemRemoved',
    'SWCallbackCustomerWishlistProductItemAdded',
    'SWCallbackCustomerWishlistProductItemRemoved',
    'SWCallbackCustomerWishlistCollectionItemAdded',
    'SWCallbackCustomerWishlistCollectionItemRemoved'
];

class SmartWishlistService {
    private existingCallbacks: SWCallbacks = {};

    private _onWishlistUpdated = new SimpleEvent<void>();
    public get onWishlistUpdated() {
        return this._onWishlistUpdated.asEvent();
    }

    constructor() {
        this.initCallbacks();
    }

    private triggerWishlistUpdated() {
        this._onWishlistUpdated.dispatch();
    }

    private callbacksInstalled = false;
    private initCallbacks() {
        if (this.callbacksInstalled) {
            this.removeCallbacks();
        }
        for (const cbName of allCallbacks) {
            // Capture existing callback
            if (typeof window[cbName] === 'function') {
                this.existingCallbacks[cbName] = window[cbName];
            }
            // Install new callback
            window[cbName] = () => {
                const oldCallback = this.existingCallbacks[cbName];
                if (oldCallback) {
                    oldCallback();
                }
                this.triggerWishlistUpdated();
            };
        }
        this.callbacksInstalled = true;
    }
    private removeCallbacks() {
        for (const cbName of allCallbacks) {
            window[cbName] = this.existingCallbacks[cbName];
        }
        this.callbacksInstalled = false;
    }
}

export const smartWishlistService = new SmartWishlistService();
